<script>
  import { timeFormat } from 'd3-time-format';
  import { thresholdTexture } from '$lib/states/index.svelte';
  let { block, latestPollDate } = $props();

  const size = 18;

  const formatDisplayDate = timeFormat('%B %-d');

  const dataAsOfText = $derived(
    latestPollDate && block.dataAsOf ?
      block.dataAsOf.replace('{date}', formatDisplayDate(latestPollDate))
    : ''
  );
</script>

<div class="note-flex">
  <svg width={size} height={size}>
    <rect width={size} height={size} x="0" y="0" fill={thresholdTexture.value}
    ></rect>
  </svg>
  <p class="threshold-note">{block.thresholdNote}</p>
</div>
{#if dataAsOfText}
  <p class="data-as-of">{dataAsOfText}</p>
{/if}

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .note-flex {
    @include mixins.fmx-auto; // center it the same way `Block`/`BodyText` center article copy
    display: flex;
    // @include mixins.fmt-2; // was a dead `fmt-2` class in markup (mixins aren't usable as classes) — space above the note
    max-width: var(
      --normal-column-width,
      660px
    ); // same column width as the body paragraph below
    @media (max-width: 740px) {
      padding-right: 50px;
      align-items: start;
    }

    // align-items: last baseline;
    align-items: start;
  }
  .threshold-note {
    font-family: 'Knowledge', sans-serif;
    font-size: 13px;
    line-height: 1.125;
    color: #666;
    flex-shrink: 1;
    margin: 0;
  }
  .data-as-of {
    @include mixins.fmx-auto;
    max-width: var(--normal-column-width, 660px);
    font-family: 'Knowledge', sans-serif;
    font-size: 13px;
    line-height: 1.125;
    color: #666;
    margin: 14px auto;
  }
  svg {
    flex-shrink: 0;
    // top: auto;
    padding-top: 2px;
    left: auto;
    width: auto;

    margin-right: 10px;
    margin-top: 0;
  }
</style>
